import { render, staticRenderFns } from "./NewsDesc.vue?vue&type=template&id=6ccd1be5&scoped=true&"
import script from "./NewsDesc.vue?vue&type=script&lang=js&"
export * from "./NewsDesc.vue?vue&type=script&lang=js&"
import style0 from "./NewsDesc.vue?vue&type=style&index=0&id=6ccd1be5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd1be5",
  null
  
)

export default component.exports